import {
  PASSO_INICIAL, PASSO_LOADING, PASSO_LOGIN_BANCO,
  PASSO_ERRO_INICIALIZAR_SDK, PASSO_TELA_INICIAL,
  PASSO_INSTRUCOES, PASSO_INICIANDO_SESSAO,
  PASSO_VERIFICANDO_STATUS, PASSO_CONCLUIDO,
  PASSO_ERRO, PASSO_CAMERA_NAO_HABILITADA,
  SITUACAO_NAO_EXECUTADA,
  SITUACAO_EXECUTADA_SUCESSO,
  SITUACAO_ERRO_SISTEMA,
  SITUACAO_SEM_DADOS,
  PASSO_PDF_INSTRUCOES_DOWNLOAD_SUCESSO,
  PASSO_PDF_INSTRUCOES_DOWNLOAD_ERRO
} from './constants'

const INITIAL_STATE = {
  passo: PASSO_INICIAL,
  percentualProcessamento: 0,
  situacao: SITUACAO_NAO_EXECUTADA,
  token: undefined,
  callsuccess: false
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'BIOMETRIA_SET_SITUACAO':
      return { ...state, situacao: action.payload }
    case 'BIOMETRIA_SET_PASSO':
      return { ...state, passo: action.payload }
    case 'BIOMETRIA_LOGIN_BANCO':
      return { ...state, passo: PASSO_LOGIN_BANCO, situacao: SITUACAO_SEM_DADOS, token: undefined }
    case 'BIOMETRIA_LOADING':
      return { ...state, passo: PASSO_LOADING, situacao: SITUACAO_NAO_EXECUTADA, token: undefined }
    case 'BIOMETRIA_ERRO_INICIALIZAR_SDK':
      return { ...state, passo: PASSO_ERRO_INICIALIZAR_SDK, situacao: SITUACAO_ERRO_SISTEMA, token: undefined }
    case 'BIOMETRIA_TELA_INICIAL':
      return { ...state, passo: PASSO_TELA_INICIAL, situacao: SITUACAO_NAO_EXECUTADA, token: undefined }
    case 'BIOMETRIA_INSTRUCOES':
      return { ...state, passo: PASSO_INSTRUCOES, situacao: SITUACAO_NAO_EXECUTADA, token: undefined }
    case 'BIOMETRIA_INICIANDO_SESSAO':
      return { ...state, passo: PASSO_INICIANDO_SESSAO, situacao: SITUACAO_NAO_EXECUTADA, token: undefined }
    case 'BIOMETRIA_VERIFICANDO_STATUS':
      return { ...state, passo: PASSO_VERIFICANDO_STATUS, percentualProcessamento: action.payload ? action.payload.percentualProcessamento : 0, situacao: SITUACAO_NAO_EXECUTADA, token: undefined }
    case 'BIOMETRIA_CONCLUIDO':
      return { ...state, passo: PASSO_CONCLUIDO, situacao: SITUACAO_EXECUTADA_SUCESSO, token: action.payload, callsuccess: false }
    case 'BIOMETRIA_CALLSUCCESS':
      return { ...state, callsuccess: true }
    case 'BIOMETRIA_CAMERA_NAO_HABILITADA':
      return { ...state, passo: PASSO_CAMERA_NAO_HABILITADA, situacao: SITUACAO_EXECUTADA_SUCESSO, token: undefined }
    case 'BIOMETRIA_ERRO':
      return { ...state, passo: PASSO_ERRO, situacao: action.payload.situacao, token: action.payload.token }
    case 'PDF_AJUDA_SOLICITADO':
      return { ...state, passo: PASSO_LOADING }
    case 'PDF_AJUDA_CARREGADO':
      return { ...state, passo: PASSO_PDF_INSTRUCOES_DOWNLOAD_SUCESSO };
    case 'PDF_AJUDA_VOLTAR':
      return { ...state, esperandoSolicitacao: false, statusDownloadPdf: '', erro: false }
    case 'PDF_AJUDA_ERRO':
      return { ...state, passo: PASSO_PDF_INSTRUCOES_DOWNLOAD_ERRO };
    default:
      return state
  }
}
